import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'components/base'

class ImportFileServiceCard extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }

  state = {
    isHovered: false,
  }

  render() {
    const { name, description, icon, onClick } = this.props

    return (
      <section
        className="import-file-service-card pointer width-full padding-normal flexbox flexbox-align-center radius-large background-transparent background-shade-50-on-hover shade-10 shade-05-on-hover font-weight-medium transition"
        onClick={onClick}
        style={{
          height: 70,
          width: '50%',
        }}
      >
        <img
          src={icon}
          className="margin-right-large"
          width="38"
          alt={`${name} icon`}
        />
        <div className="flexbox flexbox-column flexbox-justify-center height-full">
          <Text.Section className="margin-bottom-small">{name}</Text.Section>
          <Text.Corpus>{description}</Text.Corpus>
        </div>
      </section>
    )
  }
}

export default ImportFileServiceCard
